import { useIntl } from '@leagueplatform/locales';
import {
  Button,
  HeadingText,
  ParagraphText,
  StackLayout,
  Box,
  Image,
} from '@leagueplatform/genesis-core';
import { FullScreenContainer } from 'components/full-screen-container/full-screen-container.component';
import { useGetStarted } from 'hooks/use-get-started.hook';
import pageIcon from 'assets/onboarding-icon.svg';

interface GetStartedPageProps {
  handleOnboardingCompleted: () => void;
  setHasCompletedGetStarted?: (completed: boolean) => void;
}

export const GetStarted = ({
  handleOnboardingCompleted,
  setHasCompletedGetStarted,
}: GetStartedPageProps) => {
  const { formatMessage } = useIntl();
  const { descriptionMessageId, handleClick, isLoading } = useGetStarted({
    handleOnboardingCompleted,
    setHasCompletedGetStarted,
  });

  return (
    <div data-verint-suppress="true">
      <FullScreenContainer>
        <StackLayout
          orientation="vertical"
          horizontalAlignment="center"
          verticalAlignment="center"
          css={{
            height: '100%',
            whiteSpace: 'pre-wrap',
            maxWidth: '351px',
            margin: '0 auto',
          }}
        >
          <Image
            src={pageIcon}
            alt={formatMessage({ id: 'STR_GET_STARTED_IMAGE_ALT' })}
            width="176px"
            height="auto"
            css={{
              position: 'relative',
              top: '-$one',
              marginBottom: '$three',
            }}
          />
          <HeadingText level="3" size="xl" css={{ marginBottom: '$half' }}>
            {formatMessage({ id: 'STR_GET_STARTED' })}
          </HeadingText>
          <ParagraphText emphasis="subtle" css={{ textAlign: 'center' }}>
            {formatMessage({ id: descriptionMessageId as never })}
          </ParagraphText>
          <Box css={{ width: '180px', marginTop: '$twoAndHalf' }}>
            <Button
              width="fillContainer"
              onClick={handleClick}
              loading={isLoading}
              disabled={isLoading}
            >
              {formatMessage({ id: 'STR_LETS_GO' })}
            </Button>
          </Box>
        </StackLayout>
      </FullScreenContainer>
    </div>
  );
};
